import { render } from "./OfficeCalendarsTabView.vue?vue&type=template&id=6b728832&scoped=true"
import script from "./OfficeCalendarsTabView.vue?vue&type=script&lang=js"
export * from "./OfficeCalendarsTabView.vue?vue&type=script&lang=js"

import "./OfficeCalendarsTabView.vue?vue&type=style&index=0&id=6b728832&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b728832"]])

export default __exports__